import React from 'react';
import { useIsMobile } from '../../../../utils';
import { useRenderers } from '../../../../renderProps';
import FirstLoginAgreementBase from './FirstLoginAgreement';
import { ModalX } from '../../../../BaseComponents';
const FirstLoginAgreementModal = ({ modalProps, firstLoginAgreementProps }) => {
    const isMobile = useIsMobile();
    const { FirstLoginAgreement: FirstLoginAgreementOverride = FirstLoginAgreementBase } = useRenderers();
    return (React.createElement(ModalX, Object.assign({ ignoreClose: true, size: isMobile ? 'fullscreen' : 'medium' }, modalProps),
        React.createElement(FirstLoginAgreementOverride, Object.assign({}, firstLoginAgreementProps))));
};
export default FirstLoginAgreementModal;
